import { SVGProps, Ref, forwardRef } from 'react';

export const BoltFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.584 4.88 3.538 6.5C2.336 8.362 1.735 9.294 2.112 10.01c.378.717 1.47.717 3.652.717h.76c.01 2.967.1 4.476.95 4.737.95.292 1.947-1.254 3.942-4.345l1.046-1.62c1.202-1.862 1.803-2.794 1.426-3.511-.378-.717-1.47-.717-3.652-.717h-.76c-.01-2.967-.1-4.476-.95-4.737C7.577.243 6.58 1.789 4.585 4.88"
                fill="currentColor"
            />
        </g>
    </svg>
));
BoltFilledSize16Glyph.displayName = 'BoltFilledSize16Glyph';
